export default __webpack_public_path__ + "static/media/python-logo.34534379.png";